import { formatCentsToDecimals } from '../services/formatPrice';

/**
 * The suggested price in cents, or 0. One below the minimum can only come from
 * unvalidated API input, and the payment would reject it.
 */
export function getBumpSuggestedPrice(offer) {
  const suggested = Number(offer.price?.pwywSuggestedPrice) || 0;
  const minimum = Number(offer.price?.amount) || 0;
  return suggested > 0 && suggested >= minimum ? suggested : 0;
}

/**
 * The figure a pay-what-you-want bump opens with once it is added: its
 * suggested price, else its minimum, in major units as the amount box holds it.
 * Null when it has neither: "0" would read as free, so the buyer types one.
 */
export function getDefaultBumpAmount(offer) {
  const cents = getBumpSuggestedPrice(offer) || offer.price?.amount;
  if (!(cents > 0)) return null;
  return String(Number(formatCentsToDecimals(cents, offer.currency)));
}

export const isBlankAmount = amount =>
  amount === undefined || amount === null || String(amount).trim() === '';

/**
 * Every ticked pay-what-you-want bump with no figure in its box gets its
 * default, so an added bump always carries an amount the payment will accept.
 * One with no default to give comes off instead (a 0, so preselect does not
 * tick it again) and waits for the buyer to type. Returns the inputs
 * themselves when nothing changes.
 */
export default function fillOrderBumpAmounts(orderBumps, amounts, offers) {
  let nextAmounts = amounts;
  let nextOrderBumps = orderBumps;

  offers.forEach(offer => {
    const productId = String(offer.productId);
    if (!offer.price?.payWhatYouWant || !(orderBumps?.[productId] > 0)) return;
    if (!isBlankAmount(amounts?.[productId])) return;

    const amount = getDefaultBumpAmount(offer);
    if (amount === null) {
      if (nextOrderBumps === orderBumps) nextOrderBumps = { ...(orderBumps || {}) };
      nextOrderBumps[productId] = 0;
      return;
    }

    if (nextAmounts === amounts) nextAmounts = { ...(amounts || {}) };
    nextAmounts[productId] = amount;
  });

  return { orderBumps: nextOrderBumps, orderBumpAmounts: nextAmounts };
}
